// import { locales } from './locales';

// const formatPrice = (cents) => {
//   if (typeof cents === 'string') {
//     cents = parseInt(cents.replace(/\D/g, ''), 10);
//   }

//   const totalPrice = (cents / 100.0).toFixed(2);
//   const country = window.Shopify.country || 'US';
//   const locale = locales[country];
//   const currency = window.Shopify.currency.active || 'USD';

//   const price = new Intl.NumberFormat(locale, {
//     style: 'currency',
//     currency,
//   }).format(totalPrice);

//   return price.replace('.00', '');
// };

function formatPrice(cents, variantId) {
  const { prices } = window.HMR;
  if (prices.get(variantId)) {
    return prices.get(variantId);
  }
  const totalPrice = (cents / 100.0).toFixed(2);
  // const country = window.Shopify.country || 'US';
  // const locale = locales[country];
  const currency = window.Shopify.currency.active || 'USD';
  // console.info('country', country, locale, currency, totalPrice);

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(totalPrice);
}

export default formatPrice;
